<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 64px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มสถานที่</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>{{ locationInit.title_th }}</v-list-item-title>
            <v-list-item-subtitle>
              {{ locationInit.title_en }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <label class="body-2">
          สถานที่
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="1"
          v-model="location.title_th"
          :rules="[(v) => !!v || 'โปรดระบุสถานที่']"
          required
          clearable
          @change="checkEmpty($event, 'title_th')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2"> สถานที่ (อังกฤษ) </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="2"
          v-model="location.title_en"
          clearable
          @change="checkEmpty($event, 'title_en')"
          outlined
          dense
        ></v-text-field>
        <label class="body-2">
          ละติจูด
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="3"
          v-model="location.latitude"
          :rules="[
            (v) => !!v || 'โปรดระบุละติจูด',
            (v) => /^-?[0-9]*\.?[0-9]*$/.test(v) || 'ละติจูดต้องเป็นตัวเลข',
          ]"
          required
          clearable
          @click:clear="$store.commit('googleMap/SET_MARKERS', [])"
          @change="checkEmpty($event, 'latitude')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2">
          ลองจิจูด
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="4"
          v-model="location.longitude"
          :rules="[
            (v) => !!v || 'โปรดระบุลองจิจูด',
            (v) => /^-?[0-9]*\.?[0-9]*$/.test(v) || 'ลองจิจูดต้องเป็นตัวเลข',
          ]"
          required
          clearable
          @click:clear="$store.commit('googleMap/SET_MARKERS', [])"
          @change="checkEmpty($event, 'longitude')"
          outlined
          dense
        >
        </v-text-field>
        <a v-if="appMode === 'private'" :href="googleMapsUrl" target="_blank">
          Google Maps
        </a>
        <v-btn
          v-else
          outlined
          color="error"
          @click="onOpenLocationGoogleMapDialog"
        >
          <v-icon>mdi-map-marker</v-icon>
        </v-btn>
        <div class="mt-4">
          <label class="body-2">
            รัศมี (เมตร)
            <span class="red--text"><strong>*</strong></span>
          </label>
          <v-text-field
            class="fix-google-chrome mt-1"
            tabindex="5"
            v-model="location.radius_meter"
            :rules="[
              (v) => !!v || 'โปรดระบุรัศมี (เมตร)',
              (v) => /^\d+$/.test(v) || 'รัศมีต้องเป็นตัวเลขจำนวนเต็ม',
            ]"
            required
            clearable
            @change="checkEmpty($event, 'radius_meter')"
            outlined
            dense
          >
          </v-text-field>
        </div>
        <label class="body-2"> Timezone </label>
        <v-autocomplete
          class="fix-google-chrome mt-1"
          tabindex="6"
          v-model="location.timezone"
          :items="timezone"
          :rules="[(v) => !!v || 'โปรดระบุ Timezone']"
          item-text="text"
          item-value="adjustment"
          outlined
          dense
        ></v-autocomplete>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row
          justify="center"
          align="center"
          v-if="!isLocationDataChange && formAction === 'edit'"
        >
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::company_location:delete')
            "
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::company_location:create')
            "
            tabindex="7"
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::company_location:update')
            "
            tabindex="7"
            class="primary mr-3"
            depressed
            v-else
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <GoogleMap
      :dialog="googleMapDialog"
      @onSubmit="onSubmitLocationGoogleMapDialog"
      @onCancel="onCancelLocationGoogleMapDialog"
    />
  </v-navigation-drawer>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import GoogleMap from '@/components/GoogleMap.vue'

// import static data
import timezone from '@/data/timezone.json'

export default {
  components: {
    ConfirmDialog,
    GoogleMap,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    location: {
      type: Object,
    },
    locationInit: {
      type: Object,
    },
  },
  data() {
    return {
      googleMapsUrl: 'https://maps.google.com',
      appMode: process.env.VUE_APP_MODE,
      googleMapDialog: false,
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      timezone: timezone,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    locationGoogleMap() {
      return this.markers.length > 0
        ? `${this.markers[0].position.lat.toFixed(
            5
          )}, ${this.markers[0].position.lng.toFixed(5)}`
        : ''
    },
    markers() {
      return this.$store.state.googleMap.markers
    },
    markersInit() {
      return this.$store.state.googleMap.markersInit
    },
    isLocationDataChange() {
      if (
        JSON.stringify(this.markers) !== JSON.stringify(this.markersInit) ||
        this.location.title_th !== this.locationInit.title_th ||
        this.location.title_en !== this.locationInit.title_en ||
        this.location.latitude !== this.locationInit.latitude ||
        this.location.longitude !== this.locationInit.longitude ||
        this.location.radius_meter !== this.locationInit.radius_meter ||
        this.location.timezone !== this.locationInit.timezone
      ) {
        this.$emit('isLocationDataChange', true)
        return true
      }
      this.$emit('isLocationDataChange', false)
      return false
    },
  },
  methods: {
    ...mapActions({
      addLocation: 'location/addLocation',
      editLocation: 'location/editLocation',
      deleteLocation: 'location/deleteLocation',
    }),
    onOpenLocationGoogleMapDialog() {
      if (this.location.latitude && this.location.longitude) {
        const markers = []
        const latLng = {
          lat: parseFloat(this.location.latitude),
          lng: parseFloat(this.location.longitude),
        }
        markers.push({ position: latLng })
        this.$store.commit('googleMap/SET_MAP_CENTER', latLng)
        this.$store.commit('googleMap/SET_MARKERS', markers)
      }
      this.googleMapDialog = true
    },
    onSubmitLocationGoogleMapDialog() {
      if (this.locationGoogleMap) {
        const location = this.locationGoogleMap.split(', ')
        const lat = location[0]
        const lng = location[1]

        this.location.latitude = lat
        this.location.longitude = lng

        // Current date/time of user computer
        const currentDate = new Date()
        // Current UTC date/time expressed as seconds since midnight, January 1, 1970 UTC
        const timestamp =
          currentDate.getTime() / 1000 + currentDate.getTimezoneOffset() * 60

        axios
          .get(
            `https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${timestamp}&key=${process.env.VUE_APP_GOOGLE_MAP_API_KEY_CLIENT}`
          )
          .then((res) => {
            const result = res.data
            if (result.status !== 'ZERO_RESULTS') {
              const timezone = this.getTzString(result.rawOffset)
              const locationTimezone = this.timezone.find(
                (tz) => tz.adjustment === timezone
              )
              this.location.timezone = locationTimezone.adjustment
            }
            this.googleMapDialog = false
          })
      } else {
        this.googleMapDialog = false
      }
    },
    onCancelLocationGoogleMapDialog() {
      if (this.formAction === 'add') {
        this.$store.commit('googleMap/SET_MARKERS', [])

        this.location.latitude = ''
        this.location.longitude = ''
      } else {
        // this.$emit('onReset', this.formAction)
        const markers = []
        const latLng = {
          lat: parseFloat(this.locationInit.latitude),
          lng: parseFloat(this.locationInit.longitude),
        }
        markers.push({ position: latLng })
        this.$store.commit('googleMap/SET_MAP_CENTER', latLng)
        this.$store.commit('googleMap/SET_MARKERS', markers)
        this.location.latitude = this.locationInit.latitude
        this.location.longitude = this.locationInit.longitude
      }
      this.googleMapDialog = false
    },
    getTzString(offset) {
      const secInHour = 3600
      const secInMin = 60

      let isNagativeOffset = offset < 0
      let positiveOffset = Math.abs(offset)

      // hour
      let h = '' + Math.floor(positiveOffset / secInHour)
      while (h.length < 2) {
        h = '0' + h
      }
      if (isNagativeOffset) {
        h = '-' + h
      } else {
        h = '+' + h
      }

      // minute
      let m = ((positiveOffset % secInHour) / secInHour) * secInMin

      return `${h}:${m === 0 ? '00' : m}`
    },
    checkEmpty(value, field) {
      if (value) {
        this.location[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบสถานที่',
        value: this.location.title_th,
        item: this.location,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete(location) {
      const { company_uuid } = this.$store.state.authentication.company

      this.confirmDialogDeleteLoading = true

      this.deleteLocation({
        company_uuid,
        company_location_uuid: location.company_location_uuid,
      })
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const newLocation = {
          title_th: this.location.title_th,
          title_en: this.location.title_en,
          // latitude: this.markers[0].position.lat.toString(),
          // longitude: this.markers[0].position.lng.toString(),
          latitude: this.location.latitude.toString(),
          longitude: this.location.longitude.toString(),
          radius_meter: parseInt(this.location.radius_meter, 10),
          timezone: this.location.timezone,
        }

        const { company_uuid } = this.$store.state.authentication.company

        this.addLocation({
          company_uuid,
          location: newLocation,
        })
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'เพิ่มข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$emit('formActionCompleted', this.formAction)
            this.$store.commit('googleMap/SET_MARKERS', [])
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const locationUpdate = {
          title_th: this.location.title_th,
          title_en: this.location.title_en,
          // latitude: this.markers[0].position.lat.toString(),
          // longitude: this.markers[0].position.lng.toString(),
          latitude: this.location.latitude.toString(),
          longitude: this.location.longitude.toString(),
          radius_meter: parseInt(this.location.radius_meter, 10),
          timezone: this.location.timezone,
        }

        const { company_uuid } = this.$store.state.authentication.company

        this.editLocation({
          company_uuid,
          company_location_uuid: this.location.company_location_uuid,
          location: locationUpdate,
        })
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'แก้ไขข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$emit('formActionCompleted', this.formAction)
            this.$store.commit('googleMap/SET_MARKERS', [])
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onClose() {
      if (this.isLocationDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('formActionCompleted', this.formAction)
        this.$refs.form.resetValidation()
        this.$store.commit('googleMap/SET_MARKERS', [])
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$emit('formActionCompleted', this.formAction)
      this.$refs.form.resetValidation()
      this.$store.commit('googleMap/SET_MARKERS', [])
    },
    onReset() {
      if (this.formAction === 'add' || this.formAction === '') {
        this.$refs.form.resetValidation()
        this.$store.commit('googleMap/SET_MARKERS', [])
      } else {
        this.$emit('onReset', this.formAction)
      }
    },
  },
}
</script>
